import { QueryClient } from '@tanstack/react-query';
import { resetAllUserDataAtoms } from './atom-registry';
import { clearActiveScopeMirrors } from '@/store';
import type { WritableAtom } from 'jotai';

interface JotaiStore {
  set: <Value, Args extends unknown[], Result>(
    atom: WritableAtom<Value, Args, Result>,
    ...args: Args
  ) => Result;
}

export function clearAllUserData(queryClient: QueryClient, jotaiStore: JotaiStore) {
  try {
    // Clear React Query cache completely
    queryClient.clear();

    // Reset all registered user data atoms
    resetAllUserDataAtoms(jotaiStore);

    // Registry resets bypass the org/account wrapper atoms' write paths, so the
    // module-level scope mirrors (query-key builders read these) are cleared
    // explicitly alongside them (#6450).
    clearActiveScopeMirrors();

  } catch (error) {
    console.error('  ** Error clearing user data:', error);
    // Don't throw - ensure cleanup continues even if partial failure
  }
}